import type { FaireProductEntity } from "../../entity_types/product";

export const p_7vdbnrkhnm: FaireProductEntity = {
  token: "p_7vdbnrkhnm",
  type: "product",
  name: "Oversized Buttons Geometric Patchwork Knit Cardigan ZK3453",
  brandToken: "b_9qqlp5kqt7",
  brandName: "UNISHE",
  imageUrl:
    "https://cdn.faire.com/fastly/a4f4b385cc1df6484aefd46db0e102ab2f1298a14b5e6195f463a10eb0717991.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e0e93ecf258c555397195343a473d331f33cca113e7a897a6b93df19a65243c.jpeg",
    "https://cdn.faire.com/fastly/c4dc70d42df312340a50bdda33b4052253a26a7df04f53897ec4fce8d48c631e.jpeg",
    "https://cdn.faire.com/fastly/d4cb9d57c491715980a6aa9a5aad9c1ef60ee3534806cfbb17a46091d8759dfd.jpeg",
    "https://cdn.faire.com/fastly/b31d1c5439d222abd6c0cad4d628ffe701590cba875c939d3d6b127cdb826d52.jpeg",
    "https://cdn.faire.com/fastly/f53ca8586a07bc5105d806664fb4e163513c8b7efd566bc8f5a9c37d6171ffeb.jpeg",
  ],
  priceDollars: 24.93,
  description:
    "Oversized Buttons Geometric Patchwork Knit Cardigan ZK3453\n\nBold Geometric Patchwork: Eye-catching geometric patterns in contrasting colors make this cardigan a standout piece in any wardrobe.\n\nOversized Button Detail: Large, stylish buttons add a unique and fashionable touch, making it easy to dress up or down.\n\nCozy Knit Fabric: Soft, warm knit material provides comfort and insulation, perfect for cooler weather.\n\nRelaxed, Oversized Fit: Loose silhouette ensures comfort and effortless layering over shirts, tops, or dresses.\n\nVersatile Style: Ideal for casual outings, work, or cozy evenings at home, making it a practical and stylish wardrobe staple.\n\nSize Chart (cm)\t\t\t\n\t\t\t\nSize\tBust\tSleeve\tLength\nS\t100.0 \t60.0 \t99.0 \nM\t104.0 \t61.0 \t100.0 \nL\t110.0 \t62.0 \t101.0 \nXL\t116.0 \t63.0 \t102.0 \n2XL\t122.0 \t64.0 \t103.0 \n\nSize Chart (inch)\t\t\t\n\t\t\t\nSize\tBust\tSleeve\tLength\nS\t39.4 \t23.6 \t39.0 \nM\t40.9 \t24.0 \t39.4 \nL\t43.3 \t24.4 \t39.8 \nXL\t45.7 \t24.8 \t40.2 \n2XL\t48.0 \t25.2 \t40.6 \n",
  tags: [],
  msrpDollars: 49.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:51.230Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
